import PaymentTransactions from './PaymentTransactions';

export default PaymentTransactions;
